var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockInventoryConfigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 5,
    width: 13,
    height: 7,
    fill: "#FCBA46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 32,
    width: 13,
    height: 7,
    fill: "#FCBA46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 32,
    width: 13,
    height: 7,
    fill: "#FCBA46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 27.0833H6.25C2.79792 27.0833 0 29.8812 0 33.3333V50H22.9167V27.0833ZM7.29167 37.5V33.3333H15.625V37.5H7.29167ZM43.75 27.0833H27.0833V50H50V33.3333C50 29.8812 47.2021 27.0833 43.75 27.0833ZM42.7083 37.5H34.375V33.3333H42.7083V37.5ZM31.25 0H18.75C15.3042 0 12.5 2.80417 12.5 6.25V22.9167H37.5V6.25C37.5 2.80417 34.6958 0 31.25 0ZM29.1667 10.4167H20.8333V6.25H29.1667V10.4167Z",
    fill: "#802677"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockInventoryConfigLogo);
export default __webpack_public_path__ + "static/media/stockInventoryConfigLogo.06d8a85aee229599ce9fa164a4488a13.svg";
export { ForwardRef as ReactComponent };